import React from "react";
import { array, object, string, func, bool } from "prop-types";

import { MenuItem } from "../helper-components";

import "./navbar.m.css";

const Navbar = ({
  menu,
  navbarMenuStyle,
  toggleVerticalMenubar,
  dataTagCategory,
  className = "",
  pageType,
  section,
  verticalNavbar = false,
}) => {
  return (
    <nav styleName="navbar" className={`navbar ${className}`}>
      {menu && menu.length > 0 ? (
        <ul
          styleName="navbar-list"
          className={`navbar-list ${verticalNavbar && menu.length % 2 === 0 ? "even-list" : "odd-list"}`}
        >
          {menu.map((item, index) => (
            <li
              key={index}
              styleName={`menu-item  ${item["item-type"] === "placeholder" ? "menu-item-placeholder" : ""}`}
              className="menu-item"
              style={navbarMenuStyle}
            >
              <div>
                <MenuItem
                  item={item}
                  itemClick={toggleVerticalMenubar}
                  dataTagCategory={dataTagCategory}
                  isSelected={pageType === "section-page" && section ? section.name === item.title : false}
                />
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </nav>
  );
};

Navbar.propTypes = {
  menu: array,
  navbarMenuStyle: object,
  toggleVerticalMenubar: func,
  dataTagCategory: string,
  className: string,
  pageType: string,
  section: object,
  verticalNavbar: bool,
};

export default Navbar;
